"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolidIconDefinitions = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
exports.SolidIconDefinitions = {
    BOOK_OPEN_ICON: pro_solid_svg_icons_1.faBookOpen,
    CARET_DOWN_ICON: pro_solid_svg_icons_1.faCaretDown,
    INFO_CIRCLE_ICON: pro_solid_svg_icons_1.faInfoCircle,
    INFO: pro_solid_svg_icons_1.faInfo,
    PLUS_ICON: pro_solid_svg_icons_1.faPlus,
    X_MARK_ICON: pro_solid_svg_icons_1.faXmark,
    CHECK: pro_solid_svg_icons_1.faCheck,
    MENU: pro_solid_svg_icons_1.faBars,
    EYE: pro_solid_svg_icons_1.faEye,
    EYE_SLASH: pro_solid_svg_icons_1.faEyeSlash,
    WRENCH: pro_solid_svg_icons_1.faWrench,
    CHEVRON_DOWN: pro_solid_svg_icons_1.faChevronDown,
    CHEVRON_UP: pro_solid_svg_icons_1.faChevronUp,
    CHEVRON_LEFT: pro_solid_svg_icons_1.faChevronLeft,
    CHEVRON_RIGHT: pro_solid_svg_icons_1.faChevronRight,
    BARS_FILTER: pro_solid_svg_icons_1.faBarsFilter,
    ELLIPSIS: pro_solid_svg_icons_1.faEllipsis,
    CLOCK_ROTATE_LEFT: pro_solid_svg_icons_1.faClockRotateLeft,
    UP_RIGHT_AND_DOWN_LEFT_FROM_CENTER: pro_solid_svg_icons_1.faUpRightAndDownLeftFromCenter,
    DOWN_LEFT_AND_UP_RIGHT_TO_CENTER: pro_solid_svg_icons_1.faDownLeftAndUpRightToCenter,
    CIRCLE_PLAY: pro_solid_svg_icons_1.faCirclePlay,
};
